import { Gate1 } from './nativeBridge'
import { evaluateBoot, countsOf } from './core/crashLogic'

// On every JS boot: decide what the boot means (launch, reload, unclean exit)
// with the tested rules in core/crashLogic.js, then store the outcome natively.
export async function bootCrashCounter() {
    const r = await Gate1.boot()
    const result = evaluateBoot({
        state: r.state,
        bootsThisBridge: r.bootsThisBridge,
        bridgesThisProcess: r.bridgesThisProcess,
        now: Date.now(),
    })
    const state = await Gate1.applyBoot(result)
    return { state, boot: { bootsThisBridge: r.bootsThisBridge, bridgesThisProcess: r.bridgesThisProcess } }
}

export async function crashSnapshot() {
    const state = await Gate1.getState()
    return { counts: countsOf(state.events), events: state.events, runFlag: state.runFlag ?? null }
}
